__turbopack_context__.v({
  "caption": "xgEysG_caption",
  "contentWrapper": "xgEysG_contentWrapper",
  "ctaButton": "xgEysG_ctaButton",
  "hsaBanner": "xgEysG_hsaBanner",
  "playPauseBg": "xgEysG_playPauseBg",
  "playPauseButton": "xgEysG_playPauseButton",
  "playPauseIcon": "xgEysG_playPauseIcon",
  "sectionContainer": "xgEysG_sectionContainer",
  "title": "xgEysG_title",
  "topSection": "xgEysG_topSection",
  "videoContainer": "xgEysG_videoContainer",
});
